import { ALGOS_E } from "@constants/Algos";
import { createTyper } from "@mobx/services/http";
import { IMinerProfileBase, IMinerProfilesResponse } from "@services/minerProfiles";
import W2UiFilterBuilder from "@services/w2ui";
import {
  BaseResponse,
  castResponse,
  Method,
  RecordResponse,
  RequestArgs,
  RequestHandle,
} from "wl-net";

export interface IMinerProfileSaveParams {
  readonly name: string;
  readonly hash: ALGOS_E;
  readonly consumption: number;
  readonly performance: number;
  readonly meta: string;
}

export interface IMinerProfileEditParams extends IMinerProfileSaveParams {
  readonly id: number;
  readonly edit: true;
}

export interface IMinerProfileDeleteResponse extends BaseResponse { }

/**
 * External API: returns paginated miner profiles list for management screens.
 */
// export const GetMinerProfiles_RequestTypes = createTyper({
//   makeRequest(
//     handle: RequestHandle,
//     offset = 0,
//     limit = 200
//   ): RequestArgs<string> {
//     const builder = new W2UiFilterBuilder().setLimit(limit).setOffset(offset);
//     return {
//       handle,
//       method: Method.Post,
//       URL: "/miner/profile/list",
//       payload: builder.build().stringParams,
//     };
//   },
//   makeResponse: castResponse<IMinerProfilesResponse>,
// });

/**
 * External API: creates a new miner profile and returns its id in Record.
 */
export const AddMinerProfile_RequestTypes = createTyper({
  makeRequest(
    handle: RequestHandle,
    params: IMinerProfileSaveParams
  ): RequestArgs<IMinerProfileSaveParams> {
    return {
      handle,
      method: Method.Post,
      URL: "/admin/miner/profile/add",
      payload: params,
    };
  },
  makeResponse: castResponse<RecordResponse<number>>,
});

/**
 * External API: updates an existing miner profile via the legacy add endpoint.
 */
export const EditMinerProfile_RequestTypes = createTyper({
  makeRequest(
    handle: RequestHandle,
    params: IMinerProfileEditParams
  ): RequestArgs<IMinerProfileEditParams> {
    return {
      handle,
      method: Method.Post,
      URL: "/admin/miner/profile/add",
      payload: params,
    };
  },
  makeResponse: castResponse<RecordResponse<number>>,
});

/**
 * External API: deletes a miner profile by id.
 */
// export const DeleteMinerProfile_RequestTypes = createTyper({
//   makeRequest(handle: RequestHandle, id: number): RequestArgs<{ mid: number }> {
//     return {
//       handle,
//       method: Method.Post,
//       URL: "/admin/miner/profile/delete",
//       payload: { mid: id },
//     };
//   },
//   makeResponse: castResponse<IMinerProfileDeleteResponse>,
// });

export type MinerProfileRecord = IMinerProfileBase;
